
import { Link } from 'react-router-dom';

export default function StoryHero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-teal-50 via-white to-blue-50">
      {/* Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-64 h-64 bg-teal-200/30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-200/30 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-20 py-12 sm:py-16 lg:py-24 text-center">
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
          Our Story
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl text-gray-700 mb-6 sm:mb-8 max-w-3xl mx-auto leading-relaxed">
          A personal journey that became a mission to help families understand and prevent inherited heart disease
        </p>
        <Link
          to="/consultation"
          className="inline-flex items-center gap-2 bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full hover:bg-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap text-sm sm:text-base min-h-[44px]"
        >
          <span>Book a Free Consultation</span>
          <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
        </Link>
      </div>
    </section>
  );
}
